var option_default = {
  "option": "_6irrJ",
  "user_choice": "Jhcm9",
  "check": "ML8ji",
  "image": "P9giI",
  "input": "doJMI",
  "title": "OUBLa",
  "centered": "k8IV1",
  "with_result": "hgIgV",
  "list": "Xe37y",
  "with_image": "fsxGE",
  "progress": "D6t8B",
  "progress_value": "vee9f",
  "label": "DqAnw",
  "cta": "YaumB",
  "adornment_icon": "ufn2G",
  "remove": "UwnHu",
  "removeButton": "B01E1",
  "removeButtonIcon": "I3rnd",
  "overlay": "Lh8r4",
  "shown": "osV0B",
  "dark": "lU81u",
  "spinner": "I75Oa",
  "spin": "-RToL"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
